import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { getUserDetails } from "../../Utils/authUtils";

function Header() {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const user = getUserDetails();
    setUserDetails(user);
  }, []);

  const getHeaderContent = () => {
    // Check for dynamic routes first
    if (location.pathname.startsWith('/admin/planHistoryDetail/')) {
      // Extract user ID from URL
      const userId = location.pathname.split('/')[3];
      // For now, we'll show a generic description. 
      // In a real app, you might want to fetch user details here
      return {
        title: "Plan History",
        description: "Plan History > View details",
      };
    }
    
    if (location.pathname.startsWith('/admin/viewUserManagement/')) {
      return {
        title: "User Management",
        description: "User Management > View details",
      };
    }
    
    if (location.pathname.startsWith('/admin/viewMatchManagement/')) {
      return {
        title: "Match Management",
        description: "Match Management > View details",
      };
    }

    switch (location.pathname) {
      case "/admin/dashboard":
        return {
          title: "Dashboard",
          description:
            "Manage all registered users — free & premium. View profiles, activity, status, and take actions.",
        };
      case "/admin/userManagement":
        return {
          title: "User Management",
          description:
            "Manage all registered users — free & premium. View profiles, activity, status, and take actions.",
        };
      case "/admin/viewUserManagement":
        return {
          title: "User Management",
          description: "User Management > View details",
        };
      case "/admin/contentManagement":
        return {
          title: "Content Management",
          description: "Manage Profiling Questions (Dating Resume)",
        };
      case "/admin/matchManagement":
        return {
          title: "Match Management",
          description:
            "View all mutual connections created between users, their status,post-match actions and feedback.",
        };
      case "/admin/viewMatchManagement/:id":
        return {
          title: "Match Management",
          description:
            "Match Management > View details",
        };
      case "/admin/analytics&Reporting":
        return {
          title: "Analytics & Reporting",
          description:
            "View detailed analytics, user insights, and generate comprehensive reports for your platform.",
        };
      case "/admin/planManagement":
        return {
          title: "Plan Management",
          description: "",
        };
      case "/admin/settings":
        return {
          title: "Settings",
          description: "",
        };
      case "/admin/notifications":
        return {
          title: "Notifications",
          description: "",
        };
      case "/admin/planHistory":
        return {
          title: "Plan History",
          description: "",
        };
      case "/admin/campaignNotification":
        return {
          title: "Campaign Notification",
          description: "Send a notification to all users. Enter title and description below.",
        };
      default:
        return {
          title: "Dashboard",
          description:
            "Manage all registered users — free & premium. View profiles, activity, status, and take actions.",
        };
    }
  };

  const headerContent = getHeaderContent();

  const toggleNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".notification-container")) {
        setIsNotificationOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="header">
        <div className="header-left">
          <h3>{headerContent.title}</h3>
          <h4>{headerContent.description}</h4>
        </div>
        <div className="header-right">
          <div className="notification-container">
            {/* <button className="noti" onClick={toggleNotification}>
              <img
                src={window.getPublicUrl("/images/header-noti.svg")}
                alt="Notifications"
              />
            </button> */}
            {isNotificationOpen && (
              <div className="notification-dropdown">
                <div className="notification-list">
                  <div className="notification-item active">
                    <div className="notification-icon">
                      <img
                        src={window.getPublicUrl("/images/reports.svg")}
                        alt="Notification"
                      />
                    </div>
                    <div className="notification-content">
                      <p className="notification-text">Report Received</p>
                      <p className="notification-time">
                        John Deo & Alisha Roy are now matched
                      </p>
                      <p className="noti-time-adjust">12 min ago</p>
                    </div>
                    <div className="">
                      <img
                        src={window.getPublicUrl("/images/export.svg")}
                        alt="Notification"
                      />
                    </div>{" "}
                    <div className=""></div>
                  </div>
                  <div className="notification-item">
                    <div className="notification-icon">
                      <img
                        src={window.getPublicUrl("/images/create-math.svg")}
                        alt="Notification"
                      />
                    </div>
                    <div className="notification-content">
                      <p className="notification-text">Match Created</p>
                      <p className="notification-time">
                        John Deo & Alisha Roy are now matched
                      </p>
                      <p className="noti-time-adjust">12 min ago</p>
                    </div>
                    <div className="">
                      <img
                        src={window.getPublicUrl("/images/export.svg")}
                        alt="Notification"
                      />
                    </div>
                  </div>
                  <div className="notification-item">
                    <div className="notification-icon">
                      <img
                        src={window.getPublicUrl("/images/video-call.svg")}
                        alt="Notification"
                      />
                    </div>
                    <div className="notification-content">
                      <p className="notification-text">Video Call Scheduled</p>
                      <p className="notification-time">
                        Emily scheduled a call with Tom for 2 July, 5 PM
                      </p>
                      <p className="noti-time-adjust">25 min ago</p>
                    </div>
                    <div className="">
                      <img
                        src={window.getPublicUrl("/images/export.svg")}
                        alt="Notification"
                      />
                    </div>
                  </div>
                  <div className="notification-item">
                    <div className="notification-icon">
                      <img
                        src={window.getPublicUrl("/images/plan-upgrade.svg")}
                        alt="Notification"
                      />
                    </div>
                    <div className="notification-content">
                      <p className="notification-text">Plan Upgrade</p>
                      <p className="notification-time">
                        Olivia upgraded to Premium Plus
                      </p>
                      <p className="noti-time-adjust">5 min ago</p>
                    </div>
                    <div className="">
                      <img
                        src={window.getPublicUrl("/images/export.svg")}
                        alt="Notification"
                      />
                    </div>
                  </div>
                  <div className="notification-item">
                    <div className="notification-icon">
                      <img
                        src={window.getPublicUrl("/images/cv-icon.svg")}
                        alt="Notification"
                      />
                    </div>
                    <div className="notification-content">
                      <p className="notification-text">Resume Limit Reached</p>
                      <p className="notification-time">
                        Free user Jack tried to send 6th resume
                      </p>
                      <p className="noti-time-adjust">Today, 9:00 AM</p>
                    </div>
                    <div className="">
                      <img
                        src={window.getPublicUrl("/images/export.svg")}
                        alt="Notification"
                      />
                    </div>
                  </div>
                </div>
                <div className="dropdown-footer">
                  <Link to="/admin/notifications" className="view-all">
                    View all notifications
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className="admin-login">
            <Link to="/admin/settings">
              <img
                src={
                  userDetails?.User_Images?.[0]?.image ||
                  window.getPublicUrl("/images/profile.png")
                }
                alt="Admin profile"
              />
            </Link>

            <div className="admin-info">
              <h3>{userDetails?.full_name || "Admin User"}</h3>
              <h4>{userDetails?.role === 1 ? "Admin" : "User"}</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
